import React, { useState, useEffect } from 'react';
import WebsiteLayout from '../layouts/WebsiteLayout';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Section6 from '../components/Section6';
import Section7 from '../components/Section7';
import Section8 from '../components/Section8';

const About = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const isFrench = i18n.language === 'fr';

  // Determine initial service type from query parameter (default to '1')
  const queryParams = new URLSearchParams(location.search);
  const initialType = queryParams.get('type') || '1';

  const [selectedTab, setSelectedTab] = useState(initialType);
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');

  // English meta details
  const metaTitleService1En =
    'Pallet Transport | Carbon-Neutral & Efficient | Montreal – Quebec';
  const metaTitleService2En =
    'RV Dedicated Transport | Carbon-Neutral | Montreal – Quebec';
  const metaTitleService3En =
    'Machinery Transport | Carbon-Neutral | Montreal – Quebec';
  const metaTitleService4En =
    'Miscellaneous Materials Transport | Carbon-Neutral | Montreal – Quebec';

  const metaDescriptionService1En =
    'TransportSansGaz provides fast, carbon-neutral dedicated transport for pallets between Montreal and Quebec. Secure, sustainable, and cost-effective delivery.';
  const metaDescriptionService2En =
    'Need a reliable, eco-friendly transport for your RV? TransportSansGaz offers dedicated, carbon-neutral transport between Montreal and Quebec. Safe, sustainable, and efficient.';
  const metaDescriptionService3En =
    'Secure and eco-friendly dedicated transport for machinery and equipment with TransportSansGaz. Carbon-neutral service between Montreal and Quebec.';
  const metaDescriptionService4En =
    'Transporting firewood, plastic waste, sand, pellets, we offer a 100% eco-friendly alternative to conventional transport.';

  // French meta details
  const metaTitleService1Fr =
    'Transport de Palettes | Écoresponsable & Rapide | Montréal – Québec';
  const metaTitleService2Fr =
    'Transport Dédié pour VR | Carbone Neutre | Montréal – Québec';
  const metaTitleService3Fr =
    'Transport de Machines | Carbone Neutre | Montréal – Québec';
  const metaTitleService4Fr =
    'Matières en Vrac et Matériaux Divers | Carbone Neutre | Montréal – Québec';

  const metaDescriptionService1Fr =
    'TransportSansGaz assure un transport dédié et carbone neutre pour vos palettes entre Montréal et Québec. Livraison sécurisée, écologique et abordable.';
  const metaDescriptionService2Fr =
    'Besoin d’un transport fiable et écologique pour votre véhicule récréatif? TransportSansGaz offre un service dédié et carbone neutre entre Montréal et Québec. Sécurisé et durable.';
  const metaDescriptionService3Fr =
    'TransportSansGaz assure le transport sécurisé et écoresponsable de vos machines et équipements entre Montréal et Québec. Service fiable et carbone neutre.';
  const metaDescriptionService4Fr =
    'Transporter du bois de chauffage, des résidus plastiques, du sable, des granules, nous proposons une alternative 100 % écoresponsable au transport conventionnel.';

  // Update selectedTab when the URL's query parameter changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const typeFromUrl = params.get('type') || '1';
    if (typeFromUrl !== selectedTab) {
      setSelectedTab(typeFromUrl);
    }
  }, [location.search, selectedTab]);

  // Update meta title and description based on the selected service and language
  useEffect(() => {
    let title, description;

    if (isFrench) {
      switch (selectedTab) {
        case '1':
          title = metaTitleService1Fr;
          description = metaDescriptionService1Fr;
          break;
        case '2':
          title = metaTitleService2Fr;
          description = metaDescriptionService2Fr;
          break;
        case '3':
          title = metaTitleService3Fr;
          description = metaDescriptionService3Fr;
          break;
        case '4':
          title = metaTitleService4Fr;
          description = metaDescriptionService4Fr;
          break;
        default:
          title = metaTitleService1Fr;
          description = metaDescriptionService1Fr;
      }
    } else {
      switch (selectedTab) {
        case '1':
          title = metaTitleService1En;
          description = metaDescriptionService1En;
          break;
        case '2':
          title = metaTitleService2En;
          description = metaDescriptionService2En;
          break;
        case '3':
          title = metaTitleService3En;
          description = metaDescriptionService3En;
          break;
        case '4':
          title = metaTitleService4En;
          description = metaDescriptionService4En;
          break;
        default:
          title = metaTitleService1En;
          description = metaDescriptionService1En;
      }
    }
    setMetaTitle(title);
    setMetaDescription(description);
  }, [selectedTab, isFrench]);

  return (
    <WebsiteLayout>
      <Helmet>
        <html lang={isFrench ? 'fr' : 'en'} />
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <div id="services1">
        <Section6 />
      </div>
      <div id="services2">
        <Section8 />
      </div>
      <div id="services3">
        <Section7 />
      </div>
    </WebsiteLayout>
  );
};

export default About;
